module.exports = __webpack_public_path__ + "img/cabbage-posterized-medium-charlie.8a251ae2.png";